<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{ this.$route.name }}
    </div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-6">
            <a @click="openPage('/formReport/autocollection')" class="btn-grey"><i
                class="fas fa-arrow-circle-left mr-5"></i>Back</a>
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-15 pt-0">
        <div class="row justify-content-center mt-30">
          <div class="col-sm-10">
            <form @submit.prevent="validateUpload">
              <b-row class="mb-20">
                <b-col sm="2">
                  <!-- <label>Name</label> -->
                </b-col>
                <b-col sm="10">

                  <!-- <b-form-input v-model="addData.name" name="name" v-validate="'required'" type="text"></b-form-input>
                  <span class="error">{{ errors.first('name') }}</span> -->
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Excel File</label>
                </b-col>
                <b-col sm="10">
                  <input type="file" @change="onExcelUpload" v-validate="'required'" name="fileUpload" />
                  <!-- <b-form-input v-model="addData.name" name="name" v-validate="'required'" type="text"></b-form-input>
                  <span class="error">{{ errors.first('name') }}</span> -->
                </b-col>
              </b-row>
              <hr>
              <div class="text-left">
                <button type="submit" class="btn-primary">Submit</button>
              </div>
            </form>
          </div>
          <!-- Priview Table -->
        </div>
      </div>
    </div>

    <div v-if="loadingActive == true" class="loading-container">
      <div class="wrap-screen w-100 h-100">
        <img :src="`/svg-loaders/oval.svg`" width="60" alt="" />
        <div class="title-loading color-white">Loading...</div>
      </div>
    </div>

  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
import readXlsxFile from 'read-excel-file'
import moment from 'moment'

export default {
  name: 'addAutoCollection',
  data: function () {
    return {
      loadingActive: false,
      dataBranch: [],
      dataExcel: [],
      uploadExcel: false,
      addData: {
        name: '',
        parent: 'admin',
      },
      confirm_password: '',
      imageData: '',
      imgUpload: null,
      salesRole: '',
      branchSalesId: '',
      file: null,
      options: [
        { value: null, text: 'Please select' },
        { value: 'active', text: 'Active' },
        { value: 'inactive', text: 'Inactive' }
      ]
    }
  },
  methods: {
    onExcelUpload(event) {
      this.dataExcel = []
      this.uploadExcel = true
      let xlsxfile = event.target.files ? event.target.files[0] : null;
      readXlsxFile(xlsxfile).then((rows) => {
        for (let i = 0; i < rows.length; i++) {
          var myObj = new Object;
          if (i > 1) {
            for (let h = 0; h < rows[2].length; h++) {
              let v = rows[2][h] == null ? "desc" : rows[2][h].toLowerCase().replace(" ", "_").replace(".", "").replace(".", "")
              myObj[v] = rows[i][h]
            }
            // console.log(myObj)
            this.dataExcel.push(myObj)
          }
        }
        this.dataExcel = this.dataExcel.slice(1)
        // console.log('RES', this.dataExcel)
      })
    },
    validateUpload() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.loadingActive = true
          if (this.uploadExcel) {
            let dataExport = []
            console.log(this.dataExcel.length)
            for (let i = 0; i < this.dataExcel.length; i++) {
              // console.log(this.dataExcel[i])
              dataExport.push({
                member_id: this.dataExcel[i].member_id,
                account: this.dataExcel[i].acc_no,
                amount: this.dataExcel[i].trans_amount,
                name: this.dataExcel[i].name,
                periode: moment(this.dataExcel[i].periode).format('YYYY-MM-DD'),
                result: this.dataExcel[i].result,
                is_proccess: 0,
                created_by: Auth.Session.get().paradigm_user_id,
                updated_by: Auth.Session.get().paradigm_user_id
              })
            }
            // console.log(JSON.stringify(dataExport))

            // upload to server
            axios.post('crm/v1/form_auto_collection', { data: dataExport }).then(response => {
              this.loadingActive = false
              // console.log('test', response)
              // jalanin cron auto debit bca
              axios.get('transaction/v1/cron/auto_debet_bca').then(auto => {
                console.log('transaction/v1/cron/auto_debet_bca', auto)
              }).catch(error => {
                console.log('error log', error)
              })

              this.$toast.success('data saved successfully uploaded!', 'Success', {
                position: 'topCenter',
                icon: 'icon-envelope',
                progressBarColor: 'rgb(0, 255, 184)',
                theme: 'dark',
                backgroundColor: '#565c70',
                messageColor: '#fff'
              })

              this.$router.push('/formReport/autocollection')

            }).catch(error => {
              this.loadingActive = false
              // console.log('error log', error)
              this.$toast.success('cant saved data!', 'Error', {
                position: 'topCenter',
                icon: 'icon-envelope',
                progressBarColor: 'rgb(0, 255, 184)',
                theme: 'dark',
                backgroundColor: '#565c70',
                messageColor: '#fff'
              })
            })
          }

        } else {
          this.$toast.success('please fill in required fields!', 'Error', {
            position: 'topCenter',
            icon: 'icon-envelope',
            progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark',
            backgroundColor: '#565c70',
            messageColor: '#fff'
          })
        }
      })
    },
    openPage(event) {
      this.$router.push(event)
    },
    previewImage: function (event) {
      // Reference to the DOM input element
      var input = event.target;
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = (e) => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          this.imageData = e.target.result;
        }
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0]);
      }
    },
    fetchData() {
    }
  },
  created() {
    this.fetchData()
  }
}
</script>

<style></style>
